// extracted by mini-css-extract-plugin
var _1 = "zDY_vRisDO";
var _2 = "zW5Z886iJk";
export { _1 as "disabled", _2 as "root" }
